import { render, staticRenderFns } from "./editPassword.vue?vue&type=template&id=5806c22d&scoped=true&"
import script from "./editPassword.vue?vue&type=script&scoped=true&lang=js&"
export * from "./editPassword.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./editPassword.vue?vue&type=style&index=0&id=5806c22d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5806c22d",
  null
  
)

export default component.exports